import Modal from "../../components/modal";
import { Link } from "react-router-dom";
export default function AwardsPage() {
  return (
    <div
      className="hero"
      style={{
        backgroundImage:
          "url(https://static.igem.wiki/teams/4260/wiki/awards/awards-fondo.png)",
        widht: "100vw",
        minHeight: "100vh",
      }}
    >
      <div className="h-full w-full flex flex-col justify-start">
        <div className="h-auto w-auto pt-20 flex justify-between">
          <h1 className="text-9xl cano pl-20 text-white max-w-xl">
            <center></center>
          </h1>
          <div>
            {" "}
            <label className="bnt" htmlFor="gold_modal">
              <img
                className="clickable"
                src="https://static.igem.wiki/teams/4260/wiki/awards/awards-oro.png"
                alt="Fig1-sp"
                width="430"
              />
            </label>
          </div>
        </div>

        <div className="h-auto w-auto flex justify-evenly ">
          <div>
            <h1 className="text-9xl cano pl-20 text-white max-w-xl">
              <center>AWARDS</center>
            </h1>
            <h1 className="text-2xl cano pl-20 text-white max-w-xl">
              <center>(Clic on the images)</center>
            </h1>
          </div>
          <div>
            {" "}
            <label className="bnt" htmlFor="silver_modal">
              <img
                className="clickable"
                src="https://static.igem.wiki/teams/4260/wiki/awards/awards-plata.png"
                alt="Fig1-sp"
                width="430"
              />
            </label>
          </div>
        </div>
        <div className="h-auto w-auto flex justify-between pl-72">
          <div className="flex content-center">
            {" "}
            <label
              className="btn text-lg m-auto w-auto h-auto"
              htmlFor="our_modal"
              style={{
                backgroundColor: "transparent",
                borderColor: "white",
                color: "white",
              }}
            >
              Go to...<br></br> a Tour of our Achievements
            </label>
          </div>
          <div>
            {" "}
            <label className="bnt" htmlFor="bronze_modal">
              <img
                className="clickable"
                src="https://static.igem.wiki/teams/4260/wiki/awards/awards-bronce.png"
                alt="Fig1-sp"
                width="430"
              />
            </label>
          </div>
        </div>
      </div>
      <Modal modalId="gold_modal">
        <div className="h-full w-full flex justify-center">
          <div>
            <img
              src="https://static.igem.wiki/teams/4260/wiki/awards/awards-oro.png"
              alt="Fig1-sp"
              width="200"
            />
          </div>
          <div>
            <h3 className="text-9xl cano text-yellow-500">Gold</h3>
          </div>
        </div>
        <br></br>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-yellow-500">
            <em>Integrated Human Practices</em> (
            <a href="https://2022.igem.wiki/teccem/human-practices">
              <font color="blue">
                <u>Human Practices</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <ul></ul>
          <li>
            We accounted for key insights provided by each stakeholder and both
            Wet Lab and Hardware design choices adapted to fit these needs.
          </li>
          <li>
            After each design stage, we presented our implementations and
            findings to our stakeholders for feedback, repeating the cycle and
            cleaning our proposal.
          </li>
          <li>
            A mathematical model was used to measure the relation between the
            problematic affecting poverty and human health and how our project
            would have a beneficial impact.
          </li>
        </p>
        <br></br>
        <hr></hr>
        <br></br>

        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-yellow-500">
            <em>Improvement of an Existing Part</em> (→ESR1 )
          </h3>
          <br></br>
          <p className="p-justify">
            We demonstrated multiple DBTL iterations on our project, getting to
            the improvement and characterization of our biosensor hardware
            system including parts BBa_K4260001, BBa_K4260002, BBa_K4260111,
            BBa_K4260112.
          </p>
          <br></br>
        </p>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-yellow-500">
            <em>Model</em> (
            <a href="https://2022.igem.wiki/teccem/model">
              <font color="blue">
                <u>Model</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            Modeling our degradation project gained insight.
          </p>
          <br></br>
          <ul> </ul>
          <li>
            Our model can validate experimental results and predict both
            experimental parameters and results for enzymes that catalyze their
            reaction via the bi bi reaction mechanism.
          </li>
          <li>
            Allows us to design experiments by determining the most adequate
            experimental parameters (i.e. initial reactants concentration,
            initial enzyme concentration or measurement timings), → reduce waste
            liberation to the environment and exposure to hazardous compounds.
          </li>
          <br></br>
        </p>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-yellow-500">
            <em>Proof of concept</em> (
            <a href="https://2022.igem.wiki/teccem/proof-of-concept">
              <font color="blue">
                <u>Proof of concept</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            We wanted to develop an economically viable, easy-to-use and
            environmentally safe solution, with the key goal of providing a
            quantifying device and easy-to-use degradation system product to the
            stakeholders.
          </p>
          <br></br>
          <p className="p-justify">
            Since both of our prototypes are not dependent on one another, they
            create a logical synergy; knowing first the EDCs concentration in a
            sample would give rise to employ our degradation system.
          </p>
          <br></br>
          <ul></ul>
          <li>
            We integrated wet lab, hardware and software together to develop our
            biosensor. As well as nanotech for our enzymatic degradation
            systems.
          </li>
        </p>
        <br></br>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-yellow-500">
            <em>Partnership</em> (
            <a href="https://2022.igem.wiki/teccem/partnership">
              <font color="blue">
                <u>Partnership</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            Tec teams in iGEM 2022 created a partnership alliance where
            includes:
          </p>
          <br></br>
          <ul></ul>
          <li>Assessment/Advice.</li>
          <li>Mentorship.</li>
          <li>
            Laboratory reagents: shipping relevant water samples, Biobrick
            Parts, strains, plasmids and kits.
          </li>
          <li>Experimentation: synthesize nanoparticles with TecCCM 2022.</li>
          <li>
            Implementation: strategy to implement the antibiotic collection box
            proposal from Tec Guadalajara in our campus.
          </li>
          <br></br>
        </p>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-yellow-500">
            <em>Education & Communication</em> (
            <a href="https://2022.igem.wiki/teccem/communication">
              <font color="blue">
                <u>Communication</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            In order to explain Hydro-defense in a different way and involve
            farmers, agronomists and citizens (designed and promoted differently
            for each sector):
          </p>
          <br></br>
          <ul></ul>
          <li>Surveys.</li>
          <li>Social media platforms.</li>
          <li>Podcasts.</li>
          <li>Seminars and talks.</li>
          <br></br>
          <p className="p-justify">The elements we used were:</p>
          <br></br>
          <ul></ul>
          <li>Pictures.</li>
          <li>Videos.</li>
          <li>Animations.</li>
          <br></br>
          <p className="p-justify">For education:</p>
          <br></br>
          <ul></ul>
          <li>
            Encourage the youth to study a STEM career by giving laboratory
            tours.
          </li>
          <li>Coloring book for children, about SynBio and nature.</li>
        </p>
        <div class="divider"></div>
        <h3 className="text-xl cano text-yellow-500">
          <em>Results</em> (
          <Link to="/teccem/results">
            <label className="text-blue-700 underline">results</label>
          </Link>
          )
        </h3>
      </Modal>

      <Modal modalId="silver_modal">
        <div className="h-full w-full flex justify-center">
          <div>
            <img
              src="https://static.igem.wiki/teams/4260/wiki/awards/awards-plata.png"
              alt="Fig1-sp"
              width="200"
            />
          </div>
          <div>
            <h3 className="text-9xl cano text-gray-500">Silver</h3>
          </div>
        </div>
        <br></br>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-gray-500">
            <em>Engineering Success</em> (
            <a href="https://2022.igem.wiki/teccem/engineering">
              <font color="blue">
                <u>Engineering</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            We demonstrated multiple DBTL iterations on our project, getting to
            the improvement and characterization of our biosensor hardware
            system including parts BBa_K4260001, BBa_K4260002, BBa_K4260111,
            BBa_K4260112.
          </p>
          <br></br>
          <hr></hr>
          <br></br>
          <h3 className="text-xl cano text-gray-500">
            <em>Collaborations</em> (
            <a href="https://2022.igem.wiki/teccem/collaborations">
              <font color="blue">
                <u>Collaborations</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <ul></ul>
          <li>Mentorship between teams.</li>
          <li>
            Over 20 worldwide collaborations mainly focused on addressing
            environmental related issues.
          </li>
          <li className="pl-8">Bioremediation conferences</li>
          <li> Hosted meetup</li>
          <li>Water sample exchanging</li>
          <li>Agriculture handbooks</li>
          <li>Videos in our laboratory</li>
          <li>Challenges</li>
          <li>Articles and posters</li>
          <br></br>
          <hr></hr>
          <br></br>
          <h3 className="text-xl cano text-gray-500">
            <em>Human Practices</em> (
            <a href="https://2022.igem.wiki/teccem/implementation">
              <font color="blue">
                <u>Human Practices</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            We contacted and consulted a wide spectrum of stakeholders in the
            overall agriculture cycle for casting our project design and
            implementation. We included Dual Use in our human practices
            research.
          </p>
          <br></br>
          <hr></hr>
          <br></br>
          <h3 className="text-xl cano text-gray-500">
            <em>Implementation</em> (
            <a href="https://2022.igem.wiki/teccem/implementation">
              <font color="blue">
                <u>Implementation</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <p className="p-justify">
            With the correct assessment of our stakeholders, we developed a
            concrete plan to design, build and implement our project in
            agriculture and regulatory agencies to enhance irrigation water
            quality and thus, agriculture market quality. Check out our dual use
            investigation!
          </p>
        </p>
      </Modal>

      <Modal modalId="bronze_modal">
        <div className="h-full w-full flex justify-center">
          <div>
            <img
              src="https://static.igem.wiki/teams/4260/wiki/awards/awards-bronce.png"
              alt="Fig1-sp"
              width="200"
            />
          </div>
          <div>
            <h3 className="text-9xl cano text-red-900">Bronze</h3>
          </div>
        </div>
        <br></br>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-red-900">
            <em>Attributions</em> (
            <a href="https://2022.igem.wiki/teccem/attributions">
              <font color="blue">
                <u>Attributions</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
        </p>
        <hr></hr>
        <br></br>

        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-red-900">
            <em>Project description</em> (
            <a href="https://2022.igem.wiki/teccem/description">
              <font color="blue">
                <u>Project description</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
        </p>
        <hr></hr>
        <br></br>
        <p className="p-justify pl-6">
          <h3 className="text-xl cano text-red-900">
            <em>Contribution</em> (
            <a href="https://2022.igem.wiki/teccem/contribution">
              <font color="blue">
                <u>Contributions</u>
              </font>
            </a>
            )
          </h3>
          <br></br>
          <ul> </ul>
          <li>Added protein characterization data coded by BBa_K729002</li>
          <li>
            Designed and provided the schematics for an 3D printable biosensor
            hardware for piezoelectric transduction.
          </li>
          <li>Measurement software improvement</li>
          <li>
            Characterized two mathematical models; one for obtaining degradation
            enzyme assay parameters and the second for measuring impact of EDCs
            pollution and it's poverty and human health relation
          </li>
        </p>
      </Modal>

      <Modal modalId="our_modal">

                <h3 className="text-5xl cano text-pink-800">Our Goal: The Special Prizes</h3>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Best Education (<a href="https://2022.igem.wiki/teccem/education"><font color="blue"><u>Education</u></font></a>)</h3>
                    <br></br>
                    <p className="p-justify">
                        We take into consideration the conditions of our target audiences which are our external stakeholders
                        (agronomists, government and citizens).
                    </p>
                    <br></br>
                    <p className="p-justify">
                        We had to consider that many of the agronomists and farmers in Mexico live in poverty so they have
                        limited access to the  information and technology that we are developing.
                    </p>
                    <p className="p-justify pl-6"></p>
                    <br></br>
                    <ul></ul>
                    <li>We designed, wrote and created original, creative and useful content for social and digital media to
                        raise awareness.</li>
                    <br></br>
                    <li>With the feedback of people from UNESCO, we looked for new ways to attract young people into the
                        scientific field, which was accomplished by synthetic biology seminars, talks to schools and
                        collaborations with other iGEM teams. </li>
                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Best Integrated Human Practices
                        (<a href="https://2022.igem.wiki/teccem/human-practices"><font color="blue"><u>Human Practices
                        </u></font></a>)</h3>
                    <br></br>

                    <ul></ul>
                    <li>We identify and investigate within our stakeholders interests and needs. </li>
                    <br></br>
                    <li>We adapted the final product according to their identified necessities, but also we
                        contribute to the society by doing educational and volunteering activities.  </li>
                    <br></br>
                    <li>We initiated conversations with policy makers to intensify the regulation and parameters
                        of water quality in Mexico. </li>
                    <br></br>
                    <li>We create two models using tools from the economic subject, which lead us to the conclusion
                        that our project has a positive economic impact as the population of agronomists and farmers
                        that live in poverty are reduced. </li>
                    <br></br>
                    <li>Our health model was useful for the investigation as we found that the water quality and
                        agricultural production have an effect on the number of people that have a metabolism related
                        disease. </li>

                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Best Hardware (<a href="https://2022.igem.wiki/teccem/hardware"><font color="blue"><u>Hardware</u></font></a>)</h3>
                    <br></br>
                    <p>
                        The key aim of our project was to develop a Proof-of-Concept of our Biosensor assembly model and prototype,
                        where we finally immobilizating the biological recognition protein hER alpha on a chitosan surface,
                        nanoparticles amplifying the recognition signal and helping the sensibility of the quartz crystal
                        microbalance (QCM). In fusion with Mechanical Engineering, assembling and manufacturing the casing
                        of the biosensor in 3D printing was done and finally, Systems Engineering developed the software which
                        records and displays the results of the biosensor for the user to understand the information.
                        From synthetic biology to software, the resources were documented for the purpose of replicating
                        this biosensor. All areas are merged together with the intention to be practical and to ease the user
                        experience with the biosensor.

                    </p>
                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black"> Best Measurement (<a href="https://2022.igem.wiki/teccem/measurement"><font color="blue"><u>Measurement</u></font></a>)</h3>
                    <br></br>
                    <p>
                        Our degradation mathematical model predicts and helps experiments for systems with free enzymes
                        that catalyze a bi bi ping-pong reaction.
                        <br></br>
                        <br></br>
                        This determines the most adequate experimental parameters (i.e. initial reactants concentration, initial
                        enzyme concentration or measurement timings), which contributes to a reduction in  waste liberation to the
                        environment and exposure to hazardous compounds.
                    </p>
                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black"> Best Software Tool (<a href="https://2022.igem.wiki/teccem/software"><font color="blue"><u>Software</u></font></a>)</h3>
                    <br></br>
                    <ul></ul>
                    <li>Establishes a communication bridge between various data sources comprising a biosensor
                        (Laptop, Raspberry PI, and Teensy). </li>
                    <br></br>
                    <li>It was structured in such a way that it is suitable not only for our biosensing application but in any
                        type of project that requires sending signals of data from microcontrollers supporting biological
                        receptors to an end device via Bluetooth. </li>
                    <br></br>
                    <li>It uses a user-friendly Graphical User Interface developed for controlling the sensor
                        configuration and visualizing received information. </li>
                    <br></br>
                    <li>Software´s architecture  makes it easy to modify if more control parameters are needed. </li>
                    <br></br>
                    <li>Includes a noise filter for the collected data, allowing the program to interpret it in an accurate
                        and efficient way.</li>
                    <br></br>
                </p>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Best Model (<a href="https://2022.igem.wiki/teccem/model"><font color="blue"><u>Model</u></font></a>)</h3>
                    <br></br>
                    <p>
                        Modeling our degradation project gained insight.
                        <br></br>
                    </p>
                    <ul></ul>
                    <li>Our model can validate experimental results and predict both experimental parameters and results
                        for enzymes that catalyze their reaction via the bi bi reaction mechanism.</li>
                    <br></br>
                    <li>Allows us to design experiments by determining the most adequate experimental parameters
                        (i.e. initial reactants concentration, initial enzyme concentration or measurement timings),
                        → reduce waste liberation to the environment and exposure to hazardous compounds.</li>
                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Inclusivity Award (<a href="https://2022.igem.wiki/teccem/inclusivity"><font color="blue"><u>Inclusivity</u></font></a>)</h3>
                    <br></br>
                    <p>
                        Our programming team did an effortless job to include accessibility solutions such as:
                        <br></br>
                    </p>
                    <ul></ul>
                    <li>Bionic TeX: A helpful <strong>tool</strong> for <strong>neurodiverse readers</strong>, specifically
                        <strong>ADHD patients</strong>, to set <strong>information
                            attractive</strong> and at the same time, easy-to-read. </li>
                    <br></br>
                    <li>Color filters option in wiki.</li>
                    <br></br>
                    <li>Hispanic-accessible: Spanish is one of the most popular and studied mother-tongues around the globe,
                        and information in this language is scarcely found. </li>

                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Wiki</h3>
                    <br></br>
                    <p>
                        Our team wiki meets the eligibility criteria for the best wiki prize because it synthesized, in an
                        understandable manner, how everything regarding our project was carried out. Moreover, it incorporates
                        visual elements that make it completely appealing for everyone. It delivers the content in the best
                        possible way by synthesizing the information accurately and combining it with diagrams, images, and
                        different visual resources that were specifically designed with the purpose of reinforcing the main
                        ideas of each section. As a final remark, we believe that our wiki truly conveys the idea of how
                        future wikis should be and gives as much importance to the content as to the visual elements that
                        complement it.
                        <br></br>
                    </p>
                    <br></br>
                    <hr></hr>
                    <br></br>
                </p>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black">Project promotion video (<a href="https://2022.igem.wiki/teccem/description"><font color="blue"><u>Project Description</u></font></a>)</h3>
                </p>
                <br></br>
                <hr></hr>
                <br></br>

                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black"> Best New Basic Part</h3>
                    <br></br>
                    <p className="p-justify">
                        <a href="http://parts.igem.org/Part:BBa_K4260111"><font color="blue"><u>BBa_K4260111</u>
                        </font></a> → Intein mediated ESR1-Ligand-Binding-Domain → AmilCP (Protein coding)
                        <br></br>
                    </p>
                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                    <h3 className="text-2xl cano text-black"> Best New Composite Part</h3>
                    <br></br>
                    <p className="p-justify">
                        <a href="https://parts.igem.org/Part:BBa_K4260007"><font color="blue"><u>BBa_K4260007</u>
                        </font></a> :  Isoeugenol monooxygenase, normal coding sequence (composite part).
                        <br></br>
                    </p>
                </p>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                <h3 className="text-2xl cano text-black">Safety and Security Award (<a href="https://2022.igem.wiki/teccem/safety"><font color="blue"><u>Safety</u></font></a>)</h3>
                    <br></br>
                    <p className="p-justify">
                    Aim → approaching the growing risk that antimicrobial resistance represents.
                    </p>
                    <br></br>
                    <ul></ul>
                    <li>An antibiotic-free selection marker was proposal, by the use of isoeugenol and isoeugenol
                         monooxygenase as a selection system. Its effectiveness, when used on E. coli strains, was 
                         evaluated with the investigation and the realization of different experimental procedures.
                         <br></br> With the investigation, design, obtained results and the understanding of them we aim 
                         to provide the necessary tools for other people to be able to perform synthetic biology experimental
                          procedures without the need of using antibiotics.</li>
                    </p>  
                        <br></br>
                        <hr></hr>
                <br></br>
                <p className="p-justify pl-6">
                <h3 className="text-2xl cano text-black">Best Sustainable Development Impact (<a href="https://2022.igem.wiki/teccem/sustainable"><font color="blue"><u>Sustainable Development Impact</u></font></a>)</h3>
                    <br></br>
                    <p className="p-justify">
                    We aim to target four of the Sustainable Development Goals with our project; good health and well-being,
                     water and sanitation, responsible production and consumption, and life below water. 
                    </p>
                    <br></br>
                    <ul></ul>
                    <li>Our project offers an accessible detection, elimination and awareness solution to this problem.</li>
                    <br></br>
                    <li>Activities to work on other SDGs as a community, for example; quality education, climate action and 
                        partnerships to achieve different goals.</li>
                    <br></br>
                    </p>
            </Modal>
    </div>
  );
}
